export default __webpack_public_path__ + "static/media/T9-output1.ac12ef39.png";